import styled from "styled-components";
import BREAKPOINTS from "../../Theme/Breakpoints";

export const Wrapper = styled.div`
  padding: 6rem 1rem;

  .heading {
    display: flex;
    gap: 0.6rem;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;

    h1 {
      margin: 0;
      font-family: "Poppins", sans-serif;
      font-weight: 600;
      font-size: 2rem;
    }

    svg {
      font-size: 1.8rem;
    }
  }
`;

export const GalleryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
  padding: 10px;

  ${BREAKPOINTS.MOBILE} {
    gap: 6px;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }
`;

export const GalleryItem = styled.div`
  position: relative;
  cursor: pointer;
  overflow: hidden;
  border-radius: 8px;
  aspect-ratio: 1 / 1;

  ${BREAKPOINTS.MOBILE} {
    border-radius: 4px;
  }

  img {
    display: flex;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.1);
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  /* background: rgba(255, 255, 255, 0.9); */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalImage = styled.img`
  max-width: 90%;
  max-height: 80%;
  border-radius: 8px;
`;
